import { isAxiosError } from 'axios';
import axios from 'common/AxiosAuth';
import { Button, Input, Label, Modal, ModalInner } from 'components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface ModalProps {
  isOpen: boolean;  
  onConfirm: () => void; 
  onCancel: () => void;  
}

const DeleteModal = ({ isOpen, onConfirm, onCancel }: ModalProps) => {
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const nav = useNavigate();
  
  const handleDelete = async () => {
    if (!password) {
      setError('Please enter your password.');
      return;
    }
    setError('');

    try {
      await axios.delete('/api/member/account', {
        data: { currentPassword: password }
      });
      onConfirm();
      nav('/login');
    } catch (error) {
      if (isAxiosError(error) && error.response) {
        if (error.response.status === 400) {
          setError('The current password is incorrect. Please try again.');
        } else {
          setError('An error occurred while deleting your account.');
        }
      } else {
        setError('An unexpected error occurred.');
      }
    }
  };

  return (
    <Modal isOpened={isOpen} >
      <ModalInner className="md:w-[400px]" title="Delete Account" onClickClose={onCancel}>
        <p className="p-4 pt-0 text-body1">Are you sure you want to delete your account?<br/>
        This operation cannot be undone.</p>
        <div className='px-4 pb-4'>
          <div className='py-2'>
            Please enter your password to confirm<br/>
          </div>
          <Input 
            label="Password" 
            type="password" 
            value={password} 
            setValue={setPassword} 
            errorMessage={error}
          />
        </div>
        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button className="h-9" text="Cancel" onClick={onCancel} type="secondary" size="large" />
          <Button 
            className="h-9 bg-red-600 border-red-600" 
            text={"Delete"} 
            onClick={handleDelete} 
            size="large" 
            disabled={!password}
          />
        </div>
      </ModalInner>
    </Modal>
  );
};

export default DeleteModal;